import React from 'react'

export const EducationFooter = () => {
	return (
		<footer className="bg-dark text-white py-5">
			<footer className="bg-dark">
				<div className="container-xxl">
					<div className="row">
						<div className="col-lg-2 mb-4 mb-5">
							<a className="logo-container d-block" href="https://www.ghreducation.com/">
								<img src="/assets/education/scripts/logo-white.svg" alt="GHR logo" className="img-fluid" />
							</a>
						</div>
						<div className="col-lg-3 col-6 mb-5">
							<ul className="footer-nav">
								<li>
									<a href="https://www.ghreducation.com/job-opportunities">Job Seekers</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/job-opportunities/index">Job Opportunities</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/job-opportunities/what-to-expect">What to Expect</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/ghrlive">GHR Live!</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/job-opportunities/pay-benefits">Pay &amp; Benefits</a>
								</li>
							</ul>
						</div>
						<div className="col-lg-3 col-6 mb-5">
							<ul className="footer-nav">
								<li>
									<a href="https://www.ghreducation.com/staffing-solutions">Employers</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/staffing-solutions/index">Staffing Solutions</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/staffing-solutions/managed-services">Managed Services</a>
								</li>
							</ul>
						</div>
						<div className="col-lg-2 col-12 mb-5">
							<ul className="footer-nav">
								<li>
									<a href="https://www.ghreducation.com/about-us">About Us</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/about-us/index">About Us</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/about-us/corporate-careers">Corporate Careers</a>
								</li>
								<li>
									<a href="https://www.ghreducation.com/blog">Stories &amp; Resources</a>
								</li>
							</ul>
						</div>
						<div className="col-lg-2 col-12">
							<p className="fw-medium">Connect with us</p>
							<div className="footer-social">
								<a href="https://www.facebook.com/GHReducation/" target="_blank">
									<span className="icon-facebook"></span>
								</a>
								<a href="https://www.linkedin.com/company/ghreducation/" target="_blank">
									<span className="icon-linkedin"></span>
								</a>
							</div>
							<p className="fw-medium mt-3">Download the GHR Live! Job App</p>
							<p className="footer-apps">
								<a className="d-block mb-3" href="https://apps.apple.com/us/app/ghr-live/id6476303843" target="_blank">
									<img src="/assets/education/scripts/apple-badge.svg" alt="Apple Badge" />
								</a>
								<a href="https://play.google.com/store/apps/details?id=com.ghrhealthcare&amp;pcampaignid=web_share" target="_blank">
									<img src="/assets/education/scripts/google-badge.svg" alt="Google Badge" />
								</a>
							</p>
						</div>
					</div>
					<div className="row pt-4">
						<div className="col-12">
							<p className="copyright">
								© 2025 GHR Education | <a href="https://www.ghreducation.com/privacy-policy">Privacy Policy</a> |
								<a href="https://www.ghreducation.com/credits">Credits</a>
							</p>
						</div>
					</div>
				</div>
			</footer>
			<script src="/assets/education/scripts/jquery.min.js" nonce=""></script>
			<script nonce="">
				{`$(function () {
				$(document).on('keyup', '#Phone', function () {
					$(this).val($(this).val().replace(/\D/g, '').substring(0, 10))
					var size = $(this).val().length
					if (size > 0) {
						$(this).val('(' + $(this).val())
					}
					if (size > 3) {
						$(this).val($(this).val().slice(0, 4) + ') ' + $(this).val().slice(4))
					}
					if (size > 6) {
						$(this).val($(this).val().slice(0, 9) + '-' + $(this).val().slice(9))
					}
				})
				var AcuteCareNursingOptions = ['']
				var AdvancedPracticeOptions = ['']
				var AlliedHealthOptions = ['']
				var EducationOptions = [
					'BSC - Behavior Specialist Consultant',
					'COTA',
					'Certified School RN',
					'Counselor',
					'Director',
					'LBSC',
					'LCSW',
					'LPC',
					'LPN',
					'Licensed Psychologist',
					'OT',
					'PCA',
					'PT',
					'Para',
					'Paraprofessional',
					'Psych/MH Tech',
					'RN',
					'SLP',
					'Social Worker',
					'Speech Language Specialist',
					'Superintendent / Assistant Superintendent',
					'Supervisor',
					'Therapist - Occupational',
					'Therapist - Physical',
					'Therapist - Speech',
				]
				var HealthcareITOptions = ['']
				var LeadershipOptions = ['']
				var NonAcuteCareNursingOptions = ['']
				var RevCycleRCMOptions = ['']
				var OtherOptions = ['Other (Specify Below)']
				$(document).on('change', '#Discipline', function () {
					$('#Profession').html('<option value="">Profession*</option>')
					if ($(this).val() == 'Acute Care Nursing') {
						AcuteCareNursingOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					} else if ($(this).val() == 'Advanced Practice') {
						AdvancedPracticeOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					} else if ($(this).val() == 'Allied Health') {
						AlliedHealthOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					} else if ($(this).val() == 'Education') {
						EducationOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					} else if ($(this).val() == 'Healthcare IT') {
						HealthcareITOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					} else if ($(this).val() == 'Leadership') {
						LeadershipOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					} else if ($(this).val() == 'Non Acute Care Nursing') {
						NonAcuteCareNursingOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					} else if ($(this).val() == 'RevCycle (RCM)') {
						RevCycleRCMOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					} else if ($(this).val() == 'Other (Specifiy Below)') {
						OtherOptions.forEach(function (item) {
							$('#Profession').append('<option value="' + item + '">' + item + '</option>')
						})
					}
				})
				$(document).on('click', '.selection-title', function () {
					$('.collapse').collapse('hide')
				})
				$(document).on('click', '.form-check-input', function (e) {
					$(this).parent().click()
				})
				$(document).on('click', '.area', function (e) {
					e.preventDefault()
					var Area = $(this).text()
					$('.clear-search').removeClass('d-none')
					$('.areas .main').addClass('hidden')
					$('.areas .second')
						.removeClass('hidden')
						.html('<li className="menu-heading"><a href="" className="remove-area">' + Area + '</a></li>')
					$.getJSON('/assets/includes/categories', { area: Area }, function (Categories) {
						$.each(Categories, function (Key, Category) {
							$('.areas .second').append('<li><a href="" className="select-link category">' + Category + '</a></li>')
						})
						DistinctCategories()
					})
					$('#FiltersArea').append(
						'<button className="btn-remove"><input type="hidden" name="area" value="' +
							Area +
							'"><span className="icon-close-circle remove-area-sel"></span> ' +
							Area +
							'</button>'
					)
					if ($('#FiltersJobTypes').children().length > 0) $('#FiltersJobTypes').prev().removeClass('d-none')
					if ($('#FiltersState').children().length > 0) $('#FiltersState').prev().removeClass('d-none')
					DistinctJobTypes()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.remove-area', function (e) {
					e.preventDefault()
					$('.areas .second').addClass('hidden')
					$('.areas .main').removeClass('hidden')
					$('#FiltersArea')
						.find('input[value="' + $(this).text() + '"]')
						.parent()
						.remove()
					$('#FiltersArea').next().addClass('d-none')
					$('#FiltersCategory').next().addClass('d-none')
					if ($('#FiltersJobTypes').children().length > 0) $('#FiltersJobTypes').prev().addClass('d-none')
					if ($('#FiltersState').children().length > 0 && $('#FiltersJobTypes').children().length == 0) $('#FiltersState').prev().addClass('d-none')
					if ($('#FiltersJobTypes').children().length == 0 && $('#FiltersState').children().length == 0) $('.clear-search').addClass('d-none')
					DistinctJobTypes()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.remove-area-sel', function (e) {
					e.preventDefault()
					$('.areas .second').addClass('hidden')
					$('.areas .main').removeClass('hidden')
					$('.remove-specialty-sel').each(function () {
						$(this).parent().remove()
					})
					$('.remove-category-sel').parent().remove()
					$(this).parent().remove()
					$('#FiltersArea').next().addClass('d-none')
					$('#FiltersCategory').next().addClass('d-none')
					if ($('#FiltersJobTypes').children().length > 0) $('#FiltersJobTypes').prev().addClass('d-none')
					if ($('#FiltersState').children().length > 0 && $('#FiltersJobTypes').children().length == 0) $('#FiltersState').prev().addClass('d-none')
					if ($('#FiltersJobTypes').children().length == 0 && $('#FiltersState').children().length == 0) $('.clear-search').addClass('d-none')
					DistinctJobTypes()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.category', function (e) {
					e.preventDefault()
					var Category = $(this).text()
					$('.areas .second').addClass('hidden')
					$('.areas .third')
						.removeClass('hidden')
						.html('<li className="menu-heading"><a href="" className="remove-category">' + Category + '</a></li>')
					$.getJSON('/assets/includes/specialties', { category: Category }, function (Specialties) {
						$.each(Specialties, function (Key, Specialty) {
							$('.areas .third').append(
								'<li className="form-check specialty"><input className="form-check-input" type="checkbox" name="specialty" value="' +
									Specialty +
									'"><label className="form-check-label">' +
									Specialty +
									'</label></li>'
							)
						})
						DistinctSpecialties()
					})
					$('#FiltersCategory').append(
						'<button className="btn-remove"><input type="hidden" name="category" value="' +
							Category +
							'"><span className="icon-close-circle remove-category-sel"></span> ' +
							Category +
							'</button>'
					)
					$('#FiltersCategory').prev().removeClass('d-none')
					if ($('#FiltersJobTypes').children().length > 0) $('#FiltersJobTypes').prev().removeClass('d-none')
					if ($('#FiltersState').children().length > 0) $('#FiltersState').prev().removeClass('d-none')
					DistinctJobTypes()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.remove-category', function (e) {
					e.preventDefault()
					$('.areas .third').addClass('hidden')
					$('.areas .second').removeClass('hidden')
					if ($('#FiltersSpecialties').children().length > 0) $('#FiltersSpecialties').prev().addClass('d-none')
					$('.remove-specialty-sel').each(function () {
						$(this).parent().remove()
					})
					$('#FiltersCategory')
						.find('input[value="' + $(this).text() + '"]')
						.parent()
						.remove()
					$('#FiltersCategory').prev().addClass('d-none')
					if ($('#FiltersJobTypes').children().length > 0) $('#FiltersJobTypes').prev().addClass('d-none')
					if ($('#FiltersState').children().length > 0 && $('#FiltersJobTypes').children().length == 0) $('#FiltersState').prev().addClass('d-none')
					if ($('#FiltersJobTypes').children().length == 0 && $('#FiltersState').children().length == 0) $('.clear-search').addClass('d-none')
					DistinctJobTypes()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.remove-category-sel', function (e) {
					e.preventDefault()
					$('.areas .third').addClass('hidden')
					$('.areas .second').removeClass('hidden')
					if ($('#FiltersSpecialties').children().length > 0) $('#FiltersSpecialties').prev().addClass('d-none')
					$('.remove-specialty-sel').each(function () {
						$(this).parent().remove()
					})
					$(this).parent().remove()
					$('#FiltersCategory').prev().addClass('d-none')
					if ($('#FiltersJobTypes').children().length > 0) $('#FiltersJobTypes').prev().addClass('d-none')
					if ($('#FiltersState').children().length > 0 && $('#FiltersJobTypes').children().length == 0) $('#FiltersState').prev().addClass('d-none')
					if ($('#FiltersJobTypes').children().length == 0 && $('#FiltersState').children().length == 0) $('.clear-search').addClass('d-none')
					DistinctJobTypes()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.specialty', function (e) {
					if ($(this).find('input').is(':checked')) {
						$(this).find('input').prop('checked', false)
						$('#FiltersSpecialties')
							.find('input[value="' + $(this).text() + '"]')
							.parent()
							.remove()
						if ($('#FiltersSpecialties').children().length == 0) $('#FiltersSpecialties').prev().addClass('d-none')
					} else {
						$(this).find('input').prop('checked', true)
						$('#FiltersSpecialties').append(
							'<button className="btn-remove"><input type="hidden" name="specialties[]" value="' +
								$(this).find('input').val() +
								'" /><span className="icon-close-circle remove-specialty-sel"></span> ' +
								$(this).find('input').val() +
								'</button>'
						)
						$('#FiltersSpecialties').prev().removeClass('d-none')
					}
					DistinctJobTypes()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.remove-specialty-sel', function (e) {
					e.preventDefault()
					$('.specialty')
						.find('input[value="' + $(this).parent().text().trim() + '"]')
						.prop('checked', false)
					$(this).parent().remove()
					if ($('#FiltersSpecialties').children().length == 0) $('#FiltersSpecialties').prev().addClass('d-none')
					DistinctJobTypes()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.job-type', function (e) {
					if ($(this).find('input').is(':checked')) {
						$(this).find('input').prop('checked', false)
						$('#FiltersJobTypes')
							.find('input[value="' + $(this).find('input').val() + '"]')
							.parent()
							.remove()
						if ($('#FiltersJobTypes').children().length == 0 && $('#FiltersArea').children().length > 0) $('#FiltersJobTypes').prev().addClass('d-none')
						if ($('#FiltersJobTypes').children().length == 0 && $('#FiltersState').children().length > 0 && $('#FiltersArea').children().length == 0)
							$('#FiltersJobTypes').next().addClass('d-none')
						if ($('#FiltersArea').children().length == 0 && $('#FiltersJobTypes').children().length == 0 && $('#FiltersState').children().length == 0)
							$('.clear-search').addClass('d-none')
					} else {
						$('.clear-search').removeClass('d-none')
						$(this).find('input').prop('checked', true)
						$('#FiltersJobTypes').append(
							'<button className="btn-remove"><input type="hidden" name="jobtypes[]" value="' +
								$(this).find('input').val() +
								'" /><span className="icon-close-circle remove-job-type-sel"></span> ' +
								$(this).find('input').val() +
								'</button>'
						)
						if ($('#FiltersArea').children().length > 0) $('#FiltersJobTypes').prev().removeClass('d-none')
						if ($('#FiltersState').children().length > 0 && $('#FiltersArea').children().length == 0) $('#FiltersJobTypes').next().removeClass('d-none')
					}
					DistinctAreas()
					DistinctCategories()
					DistinctSpecialties()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.remove-job-type-sel', function (e) {
					e.preventDefault()
					$('.job-type')
						.find('input[value="' + $(this).parent().text().trim() + '"]')
						.prop('checked', false)
					$(this).parent().remove()
					if ($('#FiltersJobTypes').children().length == 0 && $('#FiltersArea').children().length > 0) $('#FiltersJobTypes').prev().addClass('d-none')
					if ($('#FiltersJobTypes').children().length == 0 && $('#FiltersState').children().length > 0 && $('#FiltersArea').children().length == 0)
						$('#FiltersJobTypes').next().addClass('d-none')
					if ($('#FiltersArea').children().length == 0 && $('#FiltersJobTypes').children().length == 0 && $('#FiltersState').children().length == 0)
						$('.clear-search').addClass('d-none')
					DistinctAreas()
					DistinctCategories()
					DistinctSpecialties()
					DistinctStates()
					DistinctCities()
				})
				$(document).on('click', '.state', function (e) {
					e.preventDefault()
					var State = $(this).text()
					$('.clear-search').removeClass('d-none')
					$('.states .main').addClass('hidden')
					$('.states .second')
						.removeClass('hidden')
						.html('<li className="menu-heading"><a href="" className="remove-state">' + State + '</a></li>')
					$.getJSON('/assets/includes/cities', { state: State }, function (Cities) {
						$.each(Cities, function (Key, City) {
							if (City != '')
								$('.states .second').append(
									'<li className="form-check city"><input className="form-check-input" type="checkbox" name="city" value="' +
										City +
										'"><label className="form-check-label">' +
										City +
										'</label></li>'
								)
						})
						DistinctCities()
					})
					$('#FiltersState').append(
						'<button className="btn-remove"><input type="hidden" name="state" value="' +
							State +
							'"><span className="icon-close-circle remove-state-sel"></span> ' +
							State +
							'</button>'
					)
					if ($('#FiltersArea').children().length > 0 || $('#FiltersJobTypes').children().length > 0) $('#FiltersState').prev().removeClass('d-none')
					DistinctAreas()
					DistinctCategories()
					DistinctSpecialties()
					DistinctJobTypes()
				})
				$(document).on('click', '.remove-state', function (e) {
					e.preventDefault()
					$('.states .second').addClass('hidden')
					$('.states .main').removeClass('hidden')
					if ($('#FiltersCities').children().length > 0) $('#FiltersCities').prev().addClass('d-none')
					$('.remove-city-sel').each(function () {
						$(this).parent().remove()
					})
					$('#FiltersState')
						.find('input[value="' + $(this).text() + '"]')
						.parent()
						.remove()
					if ($('#FiltersArea').children().length > 0 || $('#FiltersJobTypes').children().length > 0) $('#FiltersState').prev().addClass('d-none')
					if ($('#FiltersArea').children().length == 0 && $('#FiltersJobTypes').children().length == 0) $('.clear-search').addClass('d-none')
					DistinctAreas()
					DistinctCategories()
					DistinctSpecialties()
					DistinctJobTypes()
				})
				$(document).on('click', '.remove-state-sel', function (e) {
					e.preventDefault()
					$('.states .second').addClass('hidden')
					$('.states .main').removeClass('hidden')
					if ($('#FiltersCities').children().length > 0) $('#FiltersCities').prev().addClass('d-none')
					$('.remove-city-sel').each(function () {
						$(this).parent().remove()
					})
					$(this).parent().remove()
					$('#FiltersState')
						.find('input[value="' + $(this).text() + '"]')
						.parent()
						.remove()
					if ($('#FiltersArea').children().length > 0 || $('#FiltersJobTypes').children().length > 0) $('#FiltersState').prev().addClass('d-none')
					if ($('#FiltersArea').children().length == 0 && $('#FiltersJobTypes').children().length == 0) $('.clear-search').addClass('d-none')
					DistinctAreas()
					DistinctCategories()
					DistinctSpecialties()
					DistinctJobTypes()
				})
				$(document).on('click', '.city', function (e) {
					if ($(this).find('input').is(':checked')) {
						$(this).find('input').prop('checked', false)
						$('#FiltersCities')
							.find('input[value="' + $(this).text() + '"]')
							.parent()
							.remove()
						if ($('#FiltersCities').children().length == 0) $('#FiltersCities').prev().addClass('d-none')
					} else {
						$(this).find('input').prop('checked', true)
						$('#FiltersCities').append(
							'<button className="btn-remove"><input type="hidden" name="cities[]" value="' +
								$(this).find('input').val() +
								'" /><span className="icon-close-circle remove-city-sel"></span> ' +
								$(this).find('input').val() +
								'</button>'
						)
						$('#FiltersCities').prev().removeClass('d-none')
					}
					DistinctAreas()
					DistinctCategories()
					DistinctSpecialties()
					DistinctJobTypes()
				})
				$(document).on('click', '.remove-city-sel', function (e) {
					e.preventDefault()
					$('.city')
						.find('input[value="' + $(this).parent().text().trim() + '"]')
						.prop('checked', false)
					$(this).parent().remove()
					if ($('#FiltersCities').children().length == 0) $('#FiltersCities').prev().addClass('d-none')
					DistinctAreas()
					DistinctCategories()
					DistinctSpecialties()
					DistinctJobTypes()
				})
				$(document).on('click', '#ClearSearch', function (e) {
					e.preventDefault()
					$('.remove-area-sel').each(function () {
						$(this).click()
					})
					$('.remove-job-type-sel').each(function () {
						$(this).click()
					})
					$('.remove-state-sel').each(function () {
						$(this).click()
					})
				})
				$(document).on('click', '#ShowResults', function () {
					$('.collapse').collapse('hide')
					var Area = $('input[Name=area]').val()
					var Category = $('input[Name=category]').val()
					var Specialties = $("input[name='specialties[]']")
						.map(function () {
							return $(this).val()
						})
						.get()
					var JobTypes = $("input[name='jobtypes[]']")
						.map(function () {
							return $(this).val()
						})
						.get()
					var State = $('input[Name=state]').val()
					var Cities = $("input[name='cities[]']")
						.map(function () {
							return $(this).val()
						})
						.get()
					$.get(
						'/assets/includes/jobs-results',
						{ area: Area, category: Category, specialties: Specialties, jobtypes: JobTypes, state: State, cities: Cities },
						function (data) {
							$('#JobResults').html(data)
						}
					)
					$('html,body').animate(
						{
							scrollTop: $('#JobResultsSection').offset().top - 72,
						},
						300
					)
				})
				$(document).on('click', '#LoadMoreJobs', function (e) {
					e.preventDefault()
					$('#LoadMoreJobs').html('<img src="/images/loading.gif" />')
					$.get($(this).attr('href'), function (data) {
						$('#LoadMoreJobs').parent().replaceWith(data)
					})
				})
				$(document).on('click', '#ModifySearch', function (e) {
					e.preventDefault()
					$('html,body').animate(
						{
							scrollTop: 0,
						},
						300
					)
				})
				var Area = $('input[Name=area]').val()
				var Category = $('input[Name=category]').val()
				var Specialties = $("input[name='specialties[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var JobTypes = $("input[name='jobtypes[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var State = $('input[Name=state]').val()
				var Cities = $("input[name='cities[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				$.get(
					'/assets/includes/jobs-results',
					{ area: Area, category: Category, specialties: Specialties, jobtypes: JobTypes, state: State, cities: Cities, limit: 12 },
					function (data) {
						$('#JobResults').html(data)
					}
				)
			})
			function DistinctAreas() {
				var Category = $('input[Name=category]').val()
				var Specialties = $("input[name='specialties[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var JobTypes = $("input[name='jobtypes[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var State = $('input[Name=state]').val()
				var Cities = $("input[name='cities[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				$('.area').each(function () {
					$(this).parent().hide()
				})
				$.getJSON('/assets/includes/areas', { category: Category, specialties: Specialties, jobtypes: JobTypes, state: State, cities: Cities }, function (
					Areas
				) {
					$.each(Areas, function (Key, Area) {
						$('.area:contains("' + Area + '")')
							.parent()
							.show()
					})
				})
			}
			function DistinctCategories() {
				var Area = $('input[Name=area]').val()
				var Specialties = $("input[name='specialties[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var JobTypes = $("input[name='jobtypes[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var State = $('input[Name=state]').val()
				var Cities = $("input[name='cities[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				$('.category').each(function () {
					$(this).parent().hide()
				})
				$.getJSON('/assets/includes/categories', { area: Area, specialties: Specialties, jobtypes: JobTypes, state: State, cities: Cities }, function (
					Categories
				) {
					$.each(Categories, function (Key, Category) {
						$('.category:contains("' + Category + '")')
							.parent()
							.show()
					})
				})
			}
			function DistinctSpecialties() {
				var Area = $('input[Name=area]').val()
				var Category = $('input[Name=category]').val()
				var JobTypes = $("input[name='jobtypes[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var State = $('input[Name=state]').val()
				var Cities = $("input[name='cities[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				$('.specialty').hide()
				$.getJSON('/assets/includes/specialties', { area: Area, category: Category, jobtypes: JobTypes, state: State, cities: Cities }, function (Specialties) {
					$.each(Specialties, function (Key, Specialty) {
						$('.specialty')
							.find('input[value="' + Specialty + '"]')
							.parent()
							.show()
					})
				})
			}
			function DistinctJobTypes() {
				var Area = $('input[Name=area]').val()
				var Category = $('input[Name=category]').val()
				var Specialties = $("input[name='specialties[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var State = $('input[Name=state]').val()
				var Cities = $("input[name='cities[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				$('.job-type').hide()
				$.getJSON('/assets/includes/job-types', { area: Area, category: Category, specialties: Specialties, state: State, cities: Cities }, function (
					JobTypes
				) {
					$.each(JobTypes, function (Key, JobType) {
						$('.job-type')
							.find('input[value="' + JobType + '"]')
							.parent()
							.show()
					})
				})
			}
			function DistinctStates() {
				var Area = $('input[Name=area]').val()
				var Category = $('input[Name=category]').val()
				var Specialties = $("input[name='specialties[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var JobTypes = $("input[name='jobtypes[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var Cities = $("input[name='cities[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				$('.state').each(function () {
					$(this).parent().hide()
				})
				$.getJSON('/assets/includes/states', { area: Area, category: Category, specialties: Specialties, jobtypes: JobTypes, cities: Cities }, function (
					States
				) {
					$.each(States, function (Key, State) {
						State = State == '' ? 'Other' : State
						$('.state:contains("' + State + '")')
							.parent()
							.show()
					})
				})
			}
			function DistinctCities() {
				var Area = $('input[Name=area]').val()
				var Category = $('input[Name=category]').val()
				var Specialties = $("input[name='specialties[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var JobTypes = $("input[name='jobtypes[]']")
					.map(function () {
						return $(this).val()
					})
					.get()
				var State = $('input[Name=state]').val()
				$('.city').hide()
				$.getJSON('/assets/includes/cities', { area: Area, category: Category, specialties: Specialties, jobtypes: JobTypes, state: State }, function (Cities) {
					$.each(Cities, function (Key, City) {
						$('.city')
							.find('input[value="' + City + '"]')
							.parent()
							.show()
					})
				})
			}`}
			</script>
			<script
				src="/assets/education/scripts/bootstrap.bundle.min.js"
				nonce=""
				integrity="sha384-HwwvtgBNo3bZJJLYd8oVXjrBZt8cqVSpeBNS5n7C8IVInixGAoxmnlMuBnhbgrkm"
				crossorigin="anonymous"
			></script>
			<script src="/assets/education/scripts/plugins.js" nonce=""></script>

			<script type="text/javascript" id="" charset="">
				{`!(function (b, e, f, g, a, c, d) {
				b.fbq ||
					((a = b.fbq = function () {
						a.callMethod ? a.callMethod.apply(a, arguments) : a.queue.push(arguments)
					}),
					b._fbq || (b._fbq = a),
					(a.push = a),
					(a.loaded = !0),
					(a.version = '2.0'),
					(a.queue = []),
					(c = e.createElement(f)),
					(c.async = !0),
					(c.src = g),
					(d = e.getElementsByTagName(f)[0]),
					d.parentNode.insertBefore(c, d))
			})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
			fbq('init', '813742746898208')
			fbq('track', 'PageView')`}
			</script>

			<noscript>
				<img height="1" width="1" style={{ display: 'none' }} src="https://www.facebook.com/tr?id=813742746898208&amp;ev=PageView&amp;noscript=1" />
			</noscript>

			<script type="text/javascript" id="" charset="">
				{`var pageCount = parseInt(sessionStorage.getItem('pageCount')) || 0
			pageCount++
			sessionStorage.setItem('pageCount', pageCount)
			window.dataLayer = window.dataLayer || []
			dataLayer.push({ event: 'NewPageVisited', pageCount: pageCount })`}
			</script>
			<iframe
				height="0"
				width="0"
				style={{
					display: 'none',
					visibility: 'hidden',
				}}
				src="/assets/education/scripts/saved_resource(1).html"
			></iframe>
			<script type="text/javascript" id="" charset="">
				{`;(function (a, e, b, f, g, c, d) {
				a[b] =
					a[b] ||
					function () {
						;(a[b].q = a[b].q || []).push(arguments)
					}
				c = e.createElement(f)
				c.async = 1
				c.src = 'https://www.clarity.ms/tag/' + g + '?ref\x3dgtm2'
				d = e.getElementsByTagName(f)[0]
				d.parentNode.insertBefore(c, d)
			})(window, document, 'clarity', 'script', 'mvmrui0cqx')`}
			</script>
			<script src="/assets/education/scripts/script.js" nonce=""></script>
			<script>
				{`;(function (a, b, c, d, e, m) {
				a['OktopostTrackerObject'] = d
				a[d] =
					a[d] ||
					function () {
						;(a[d].q = a[d].q || []).push(arguments)
					}
				e = b.createElement('script')
				m = b.getElementsByTagName('script')[0]
				e.async = 1
				e.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + c
				m.parentNode.insertBefore(e, m)
			})(window, document, 'static.oktopost.com/oktrk.js', '_oktrk')
			_oktrk('create', '001jydbzelwy1lb')`}
			</script>
			<script type="text/javascript" id="hs-script-loader" async="" defer="" src="/assets/education/scripts/49047433(1).js"></script>
			<script
				src="/assets/education/scripts/widget_app_base_1739794703874.js"
				async=""
				id="a11yWidgetSrc"
				crossorigin="anonymous"
				integrity="sha256-8/dvkPVcPvT5Y9oAdZQKvnTGr7k8GqON8QMhj3oTtqI="
			></script>
			<div id="veepn-guard-alert">
				<template shadowrootmode="open">
					<style>
						{`html {
						box-sizing: border-box;
						text-size-adjust: 100%;
						word-break: normal;
						-moz-tab-size: 4;
						tab-size: 4;
					}
					*,
					:before,
					:after {
						background-repeat: no-repeat;
						box-sizing: border-box;
					}
					:before,
					:after {
						text-decoration: inherit;
						vertical-align: inherit;
					}
					* {
						padding: 0;
						margin: 0;
					}
					hr {
						overflow: visible;
						height: 0;
						color: inherit;
						border: 0;
						border-top: 1px solid;
					}
					details,
					main {
						display: block;
					}
					summary {
						display: list-item;
					}
					small {
						font-size: 80%;
					}
					[hidden] {
						display: none;
					}
					abbr[title] {
						border-bottom: none;
						text-decoration: underline;
						text-decoration: underline dotted;
					}
					a {
						background-color: transparent;
					}
					a:active,
					a:hover {
						outline-width: 0;
					}
					code,
					kbd,
					pre,
					samp {
						font-family: monospace;
					}
					pre {
						font-size: 1em;
					}
					b,
					strong {
						font-weight: bolder;
					}
					sub,
					sup {
						font-size: 75%;
						line-height: 0;
						position: relative;
						vertical-align: baseline;
					}
					sub {
						bottom: -0.25em;
					}
					sup {
						top: -0.5em;
					}
					table {
						border-color: inherit;
						text-indent: 0;
					}
					iframe {
						border-style: none;
					}
					input {
						border-radius: 0;
					}
					[type='number']::-webkit-inner-spin-button,
					[type='number']::-webkit-outer-spin-button {
						height: auto;
					}
					[type='search'] {
						-webkit-appearance: textfield;
						-moz-appearance: textfield;
						appearance: textfield;
						outline-offset: -2px;
					}
					[type='search']::-webkit-search-decoration {
						-webkit-appearance: none;
						-moz-appearance: none;
						appearance: none;
					}
					textarea {
						overflow: auto;
						resize: vertical;
					}
					button,
					input,
					optgroup,
					select,
					textarea {
						font: inherit;
						color: inherit;
					}
					optgroup {
						font-weight: 700;
					}
					button {
						overflow: visible;
					}
					button,
					select {
						text-transform: none;
					}
					button,
					[type='button'],
					[type='reset'],
					[type='submit'],
					[role='button'] {
						cursor: pointer;
					}
					button::-moz-focus-inner,
					[type='button']::-moz-focus-inner,
					[type='reset']::-moz-focus-inner,
					[type='submit']::-moz-focus-inner {
						border-style: none;
						padding: 0;
					}
					button,
					html [type='button'],
					[type='reset'],
					[type='submit'] {
						-webkit-appearance: button;
						-moz-appearance: button;
						appearance: button;
					}
					button,
					input,
					select,
					textarea {
						background-color: transparent;
						border-style: none;
					}
					button:-moz-focusring,
					[type='button']::-moz-focus-inner,
					[type='reset']::-moz-focus-inner,
					[type='submit']::-moz-focus-inner {
						outline: 1px dotted ButtonText;
					}
					select {
						-webkit-appearance: none;
						-moz-appearance: none;
						appearance: none;
					}
					a:focus,
					button:focus,
					input:focus,
					select:focus,
					textarea:focus {
						outline-width: 0;
					}
					select::-ms-expand {
						display: none;
					}
					select::-ms-value {
						color: currentcolor;
					}
					legend {
						border: 0;
						color: inherit;
						display: table;
						white-space: normal;
						max-width: 100%;
					}
					::-webkit-file-upload-button {
						-webkit-appearance: button;
						-moz-appearance: button;
						appearance: button;
						color: inherit;
						font: inherit;
					}
					[disabled] {
						cursor: default;
					}
					img {
						border-style: none;
					}
					progress {
						vertical-align: baseline;
					}
					[aria-busy='true'] {
						cursor: progress;
					}
					[aria-controls] {
						cursor: pointer;
					}
					[aria-disabled='true'] {
						cursor: default;
					}
					ul,
					ol {
						list-style-type: none;
					}
					figure {
						margin: 0;
					}
					.guard-popup {
						font-family: FigtreeVF, sans-serif;
						position: fixed;
						z-index: 2147483638;
						top: 8px;
						left: 24px;
						overflow: visible;
						color: #222e3a;
						background-color: #fff;
						max-width: 416px;
						width: calc(100% - 48px);
						border-radius: 16px;
						box-shadow: 0 4px 20px #00000040;
						padding: 24px;
					}
					.guard-popup__header {
						display: flex;
						justify-content: space-between;
						align-items: center;
						column-gap: 16px;
						margin-bottom: 24px;
					}
					.guard-popup__close {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 24px;
						height: 24px;
						opacity: 0.7;
					}
					.guard-popup__img {
						line-height: 0;
						margin-bottom: 24px;
					}
					.guard-popup__img img {
						width: 100%;
						aspect-ratio: 368/142;
						object-fit: cover;
						border-radius: 12px;
						overflow: hidden;
					}
					.guard-popup__title {
						font-size: 24px;
						line-height: 32px;
						margin-bottom: 8px;
					}
					.guard-popup__description {
						font-size: 20px;
						line-height: 28px;
						font-weight: 500;
						color: #4a5764;
						margin-bottom: 28px;
					}
					.guard-popup__actions {
						display: flex;
						justify-content: flex-end;
						column-gap: 16px;
					}
					.guard-popup__btn {
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 8px 16px;
						border-radius: 5px;
						font-size: 16px;
						line-height: 24px;
						font-weight: 700;
						cursor: pointer;
						color: #fff;
						background: linear-gradient(180deg, #5695fd, #1554ff);
					}`}
					</style>
				</template>
			</div>
			<style>
				{`@font-face {
				font-family: FigtreeVF;
				src: url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2) format('woff2 supports variations'),
					url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2) format('woff2-variations');
				font-weight: 100 1000;
				font-display: swap;
			}`}
			</style>
			<div id="veepn-breach-alert">
				<template shadowrootmode="open">
					<style>
						{`
					.breach-popup {
						font-family: FigtreeVF, sans-serif;
						position: fixed;
						z-index: 2147483638;
						text-rendering: optimizelegibility;
						top: 0;
						left: 0;
						right: 0;
						pointer-events: none;
						padding-inline: 16px;
						height: 0;
						overflow: visible;
						color: #222e3a;
					}
					.breach-popup * {
						box-sizing: border-box;
					}
					.breach-popup__inner {
						background-color: #de4558;
						width: 100%;
						border-radius: 16px;
						margin-inline: auto;
						pointer-events: all;
						position: relative;
						transition: transform 0.25s ease-in-out, max-width 0.25s ease-in-out;
						transform: translateY(16px);
						max-height: calc(100svh - 80px);
						display: flex;
						flex-direction: column;
					}
					.breach-popup__header {
						min-height: 32px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						column-gap: 16px;
						padding: 4px;
						cursor: pointer;
					}
					.breach-popup__close {
						cursor: pointer;
						background-color: transparent;
						border-style: none;
						outline: none;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 24px;
						height: 24px;
						flex-shrink: 0;
						opacity: 0.5;
					}
					.breach-popup__wrap {
						display: grid;
						grid-template-rows: 0fr;
						transition: grid-template-rows 0.25s ease-in-out;
						overflow: hidden;
					}
					.breach-popup__content {
						overflow: hidden;
						opacity: 0;
						transform: translateY(-10px);
					}
					.breach-popup--minimize .breach-popup__inner {
						max-width: 485px;
						transform: translateY(-100%);
					}
					.breach-popup--collapse .breach-popup__inner {
						max-width: 485px;
					}
					.breach-popup--expand .breach-popup__inner {
						max-width: 1120px;
					}
					.breach-popup--expand .breach-popup__wrap {
						grid-template-rows: 1fr;
					}
					.breach-popup--expand .breach-popup__content {
						opacity: 1;
						transform: translateY(0);
						transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
						transition-delay: 0.15s;
					}
					.breach-popup--expand .breach-popup__header {
						cursor: default;
					}
					.breach-info {
						padding: 2px;
						height: 100%;
					}
					.breach-info__inner {
						padding: 22px 22px 0;
						background-color: #fff;
						border-bottom-left-radius: 15px;
						border-bottom-right-radius: 15px;
						height: 100%;
						overflow: auto;
					}
					.breach-info__alert {
						font-size: 24px;
						line-height: 32px;
						font-weight: 700;
						margin: 0;
					}
					.breach-info__list {
						margin-top: 24px;
						display: flex;
						flex-wrap: wrap;
						gap: 24px;
					}
					@media only screen and (width >= 992px) {
						.breach-info__list {
							flex-wrap: nowrap;
						}
					}
					.breach-info__item {
						width: 100%;
					}
					.breach-info__item:nth-child(2) {
						max-width: 320px;
					}
					.breach-info__item:nth-child(3) {
						max-width: 200px;
					}
					.breach-info__title {
						font-size: 18px;
						font-weight: 700;
						line-height: 32px;
						letter-spacing: -0.1px;
						color: #de4558;
						margin-top: 0;
						margin-bottom: 4px;
					}
					.breach-info__description {
						font-size: 16px;
						line-height: 28px;
						letter-spacing: -0.1px;
					}
					.breach-info__description ul {
						margin: 0;
					}
					.breach-info__actions {
						display: flex;
						justify-content: center;
						padding-top: 32px;
						padding-bottom: 22px;
						background-color: #fff;
						position: sticky;
						bottom: 0;
					}
					.breach-info__btn {
						cursor: pointer;
						border-style: none;
						outline: none;
						display: inline-flex;
						align-items: center;
						height: 48px;
						padding-inline: 20px;
						border-radius: 12px;
						text-align: center;
						font-size: 16px;
						font-weight: 700;
						line-height: 28px;
						letter-spacing: -0.1px;
						color: #fff;
						background-color: #ff6400;
					}
					.button-expand {
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translate(-50%, 100%);
						z-index: 1;
					}
					.button-expand__pointer {
						cursor: pointer;
					}
					.button-expand__alert {
						pointer-events: none;
						transition: opacity 0.25s ease-in-out;
					}
					.button-expand__arrow {
						pointer-events: none;
						transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
						transform-origin: center;
					}
					.button-expand--minimize .button-expand__arrow,
					.button-expand--collapse .button-expand__alert,
					.button-expand--expand .button-expand__alert {
						opacity: 0;
					}
					.button-expand--expand .button-expand__arrow {
						transform: rotate(180deg);
					}
					.header-collapse {
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						column-gap: 4px;
						padding-left: 8px;
						font-size: 14px;
						line-height: 20px;
						letter-spacing: -0.1px;
						color: #fff;
					}
					.header-expand {
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						column-gap: 4px;
						padding-left: 20px;
						font-size: 14px;
						font-weight: 500;
						line-height: 20px;
						letter-spacing: -0.1px;
						color: #fff;
					}`}
					</style>
				</template>
			</div>
			<style>
				{`@font-face {
				font-family: FigtreeVF;
				src: url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2) format('woff2 supports variations'),
					url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2) format('woff2-variations');
				font-weight: 100 1000;
				font-display: swap;
			}`}
			</style>
			<script
				crossorigin="anonymous"
				integrity="sha256-Lw4AFTYCz7uUZIz3B+RL+v8yUPwLSA+hbOqILL0MnMU="
				src="/assets/education/scripts/remediation_1739794703874.js"
			></script>
		</footer>
	)
}
